import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { IGetAllocatorAgencies } from 'redux/types/Agent.types';

export interface AgencyState {
  data: any | null;
  loading: boolean;
  error: string | null;
  downloadAgencyExcelError: string | null;
  activateAgencyStatus: boolean | null;
  agencies: IGetAllocatorAgencies | null;
}

export interface ActivateAgencyRequest {
  id: string;
}

export const agencyDetailsSliceState: AgencyState = {
  data: null,
  loading: false,
  error: null,
  downloadAgencyExcelError: null,
  activateAgencyStatus: null,
  agencies: null,
};

const agencyDetailsSlice = createSlice({
  name: 'agencyDetails',
  initialState: agencyDetailsSliceState,
  reducers: {
    fetchAgencyDetailsRequest: (state, action: PayloadAction<string>) => {
      state.loading = true;
      state.error = null;
    },
    fetchAgencyDetailsSuccess: (state, action: PayloadAction<any>) => {
      state.data = action.payload;
      state.loading = false;
    },
    fetchAgencyDetailsFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
    downloadAgencyExcelRequest: (state) => {
      state.loading = true;
      state.downloadAgencyExcelError = null;
    },
    downloadAgencyExcelFailure: (state, action: PayloadAction<string>) => {
      state.downloadAgencyExcelError = action.payload;
      state.loading = false;
    },
    activateAgencyRequest: (
      state,
      action: PayloadAction<ActivateAgencyRequest>
    ) => {
      state.loading = true;
      state.activateAgencyStatus = null;
    },
    activateAgencySuccess: (state) => {
      state.activateAgencyStatus = true;
      state.loading = false;
    },
    activateAgencyFailure: (state) => {
      state.activateAgencyStatus = false;
    },
    fetchAllocatorAgencies: (
      state,
      action: PayloadAction<{ allocatorId: string }>
    ) => {
      state.loading = true;
      state.error = null;
    },
    fetchAllocatorAgenciesSuccess: (
      state,
      action: PayloadAction<IGetAllocatorAgencies>
    ) => {
      state.loading = false;
      state.agencies = action.payload;
    },
    fetchAllocatorAgenciesFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
    resetActivationStatus: (state) => {
      state.activateAgencyStatus = null;
    },
  },
});

export const {
  fetchAgencyDetailsRequest,
  fetchAgencyDetailsSuccess,
  fetchAgencyDetailsFailure,
  downloadAgencyExcelRequest,
  downloadAgencyExcelFailure,
  activateAgencyRequest,
  activateAgencySuccess,
  activateAgencyFailure,
  fetchAllocatorAgencies,
  fetchAllocatorAgenciesSuccess,
  fetchAllocatorAgenciesFailure,
  resetActivationStatus,
} = agencyDetailsSlice.actions;

export default agencyDetailsSlice.reducer;
